(function () {
  'use strict';

  function placeMobileBar() {
    document.querySelectorAll('[data-product-photos]').forEach(function (slideshow) {
      var photos = slideshow.closest('.product__photos');
      if (photos && photos.classList.contains('product__photos--mobile-thumbnails')) return;
      if (photos && photos.classList.contains('product__photos--mobile-progress')) return;

      var mainPhotos = slideshow.closest('.product__main-photos');
      if (!mainPhotos) return;

      var mobile = mainPhotos.querySelector('.model-sizing-mobile');
      var dots = slideshow.querySelector('.flickity-page-dots');

      if (!mobile || !dots || mobile.nextElementSibling === dots) return;

      slideshow.insertBefore(mobile, dots);
    });
  }

  function init() {
    placeMobileBar();

    document.querySelectorAll('.model-sizing-badge').forEach(function (badge) {
      if (badge.dataset.modelSizingBound) return;
      badge.dataset.modelSizingBound = 'true';

      badge.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.setTimeout(init, 500);
  window.setTimeout(init, 1500);
})();
